import axios from 'axios';
import URLS from '../../../util/urls.js';

const state = {
  boletos: [],
  alugueis: [],
  repasses: [],
  clientes: [],

  tabSelecionada: 'cobrancas',
}

const mutations = {
  atualizarBoletos(state, payload) {
    state.boletos = payload;
    state.boletos = state.boletos.map(item => { return item.recibo ? item.recibo : item.boletoAvulso })
    state.boletos = state.boletos.map(item => { return { ...item, selecionado: false }});
  },
  atualizarRepasses(state, payload) {
    state.repasses = payload
    state.repasses = state.repasses.map(item => { return item.recibo });
    state.repasses = state.repasses.map(item => { return { ...item, selecionado: false } });
  },
  selecionarTodos(state){
    state.boletos = state.boletos.map(item => { return { ...item, selecionado: true }});
  },
  deselecionarTodos(state){
    state.boletos = state.boletos.map(item => { return { ...item, selecionado: false }});
  },
  selecionarTodosRepasses(state){
    state.repasses = state.repasses.map(item => { return { ...item, selecionado: item.aluguel.contasBancariasRepasse[0].contaBancaria.id > 0 ? true : false }});
  },
  deselecionarTodosRepasses(state){
    state.repasses = state.repasses.map(item => { return { ...item, selecionado: false }});
  },
  atualizarListaAlugueis(state, payload) {
    state.alugueis = payload;
  },
  atualizarListaClientes(state, payload) {
    state.clientes = payload;
  },
  atualizarTabSelecionada(state, payload) {
    state.tabSelecionada = payload;
  },
  limparBoletos(state) {
    state.boletos = []
  },
  limparRepasses(state) {
    state.repasses = []
  }
}

const actions = {
  listarBoletos(context, payload) {
    return axios.post(URLS.REMESSAS_LISTAR_BOLETOS_REMESSA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarBoletos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarBoletos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarRepasses(context, payload) {
    return axios.post(URLS.REMESSAS_LISTAR_REPASSES_REMESSA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit("atualizarRepasses", response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarRepasses', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarAlugueis(context, payload) {
    return axios.post(URLS.ALUGUEIS_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit("atualizarListaAlugueis", response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarAlugueis", payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit("atualizarListaClientes", response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarClientes", payload);
            }
          }).catch(error => {
            throw error;
          });
      }
    }).catch(error => {
      throw error;
    });
  },

  recuperarNumeroRemessa(context, payload) {
    let url = state.tabSelecionada == 'cobrancas' ? URLS.REMESSAS_RECUPERAR_NUMERO_DA_REMESSA : URLS.REMESSAS_RECUPERAR_NUMERO_DA_REMESSA_PAGAMENTOS

    return axios.post(url, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarNumeroRemessa', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarRemessa(context, payload) {
    let url = state.tabSelecionada == 'cobrancas' ? URLS.REMESSAS_GERAR_ARQUIVO_REMESSA : URLS.REMESSAS_GERAR_ARQUIVO_REMESSA_PAGAMENTOS

    return axios.post(url, payload)
    .then((response) => {
      return response
    }).catch((error) => {
      throw error;
    });
  },

  selecionarTodos(context) {
    context.commit('selecionarTodos');
  },
  deselecionarTodos(context) {
    context.commit('deselecionarTodos');
  },
  selecionarTodosRepasses(context) {
    context.commit('selecionarTodosRepasses');
  },
  deselecionarTodosRepasses(context) {
    context.commit('deselecionarTodosRepasses');
  }
}

export default {
  state,
  mutations,
  actions
}